import React from "react";
import { useSelector } from "react-redux";
import { makeStyles, Typography } from "@material-ui/core";
import { ROTATION_TYPES } from "../../../actions/app/constants";

const useStyles = makeStyles((theme) => ({
  typography: {
    paddingBottom: 10,
    wordBreak: "break-all"
  },
  title: {
    fontWeight: "bolder"
  },
  div: {
    color: theme.palette.text.secondary
  }
}));

export default function CreativeDetails({ isDefault }) {
  const classes = useStyles();
  const creatives = useSelector((state) => state.creatives);
  const campaigns = useSelector((state) => state.dcmCampaigns);
  const startDate = useSelector((state) => state.creatives.startDate);
  const endDate = useSelector((state) => state.creatives.endDate);

  let creativeArray = Object.values(creatives.byId);

  return (
    <div className={classes.div}>
      <Typography className={classes.title}>Campaign:</Typography>
      <Typography variant="body1" className={classes.typography}>
        {campaigns.byId[campaigns.selectedId].name}
      </Typography>
      {creatives.assignedPlacements.length > 0 ? (
        <>
          <Typography className={classes.title}>Placement(s):</Typography>
          <Typography
            component={"ul"}
            variant="body1"
            className={classes.typography}
          >
            {creatives.assignedPlacements.map((placement) => {
              return (
                <li key={`placement-${placement.id}`}>{placement.name}</li>
              );
            })}
          </Typography>
        </>
      ) : null}

      <Typography className={classes.title}>Creative Type: </Typography>
      <Typography variant="body1" className={classes.typography}>
        {isDefault
          ? "DEFAULT"
          : creativeArray[0].taxonomy.format}
      </Typography>
      <Typography className={classes.title}>Dimensions:</Typography>
      <Typography variant="body1" className={classes.typography}>
        {creativeArray[0].taxonomy.dimensions}
      </Typography>
      {!isDefault ? (
        <>
          {" "}
          <Typography className={classes.title}>Rotation Type: </Typography>
          <Typography variant="body1" className={classes.typography}>
            {creatives.rotationType.charAt(0) +
              creatives.rotationType
                .slice(1)
                .toLowerCase()
                .replace("_", "")
                .replace("_", " ")}
          </Typography>
          <Typography className={classes.title}>Weight: </Typography>
          {creatives.rotationType === ROTATION_TYPES.WEIGHTED && (
            <Typography variant="body1" className={classes.typography}>
              {creatives.weightDistribution.charAt(0) +
                creatives.weightDistribution.slice(1).toLowerCase()}
            </Typography>
          )}
        </>
      ) : null}

      {creatives.dynamicTargetingKeys.length > 0 && (
        <>
          <Typography className={classes.title}>
            Dynamic Targeting Keys:
          </Typography>
          <Typography variant="body1" className={classes.typography}>
            {creatives.dynamicTargetingKeys.map((key) => key.name).join(", ")}
          </Typography>
        </>
      )}

      <>
        <Typography className={classes.title}>
          Delivery Start Date and Time
        </Typography>
        <Typography variant="body1" className={classes.typography}>
          {startDate.format("YYYY-MM-DD HH:mm")}
        </Typography>
      </>
      <>
        <Typography className={classes.title}>
          Delivery End Date and Time
        </Typography>
        <Typography variant="body1" className={classes.typography}>
          {endDate.format("YYYY-MM-DD HH:mm")}
        </Typography>
      </>

    </div>
  );
}
